import React from "react";
import { Card } from "react-bootstrap";

const Cards = ({ title, text }) => {
  return (
    <Card
      className="mb-4 rounded-5 mx-auto"
      style={{
        minHeight: "300px",
      }}
    >
      <Card.Body style={{justifyContent: 'center', alignContent: 'center'}}>
        <Card.Title className="fs-1 fw-bold text-uppercase">{title}</Card.Title>
        <Card.Text className="fs-4">{text}</Card.Text>
      </Card.Body>
    </Card>
  );
};

export default Cards;
